import { privateClient } from '.';

const path = '/cursos';

async function Novo(dados) {
	return await privateClient({
		path: `${path}`,
		params: {
			method: 'POST',
			body: JSON.stringify(dados),
		},
	});
}

async function ConsultaPelaId(id) {
	return await privateClient({
		path: `${path}/${id}`,
	});
}

async function ListaTodos() {
	return await privateClient({
		path: `${path}`,
	});
}

const cursos = {
	Novo,
	ConsultaPelaId,
	ListaTodos,
};

export default cursos;
